<template>
  <div class="ma-6">
    <v-stepper v-model="stepsellerreg">
      <v-stepper-header>
        <v-stepper-step
            :complete="stepsellerreg  > 1"
            step="1"
        >
          Ducument Identitas
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="stepsellerreg > 2" step="2">
          Menunggu Verifikasi
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
            :complete="stepsellerreg > 3"
            step="3"
        >
          API Integrasi
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">
          Finish
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="mb-12 row boxidentitas">
            <v-container class="">
              <v-row justify="center">
                <v-col cols="12" lg="4">
                  <KTPUpload label="Foto KTP"/>
                </v-col>
                <v-col cols="12" lg="4">
                  <NPWPUpload label="Foto NPWP (Optional)"/>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <v-btn color="primary" @click="setSellerDocument(sellerdoc)">Continue</v-btn>
          <v-btn text>Cancel</v-btn>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-row justify="center">
            <img class="imgconfm" alt="waitingconfm" src="../assets/waitingconfmseller.png"/>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="3">
           <v-row>
              <v-col cols="12" lg="4" md="4">
<!--                <div class="mt-0">-->
<!--                  <v-select-->
<!--                      label="Jenis API"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      v-model="jenisapi"-->
<!--                      :items="jenisapis"-->
<!--                      return-object-->
<!--                  ></v-select>-->
<!--                </div>-->
                <div><v-text-field v-model="sellerapi.userid" label="UserID"></v-text-field></div>
                <div><v-text-field type="password" v-model="sellerapi.pin" label="PIN"></v-text-field></div>
                <div><v-text-field type="password" v-model="sellerapi.username" label="UserName"></v-text-field></div>
                <div><v-text-field type="password" v-model="sellerapi.password" label="Password"></v-text-field></div>
                <div><v-text-field v-model="sellerapi.apiurl" label="Api URL"></v-text-field></div>
              </v-col>
             <v-col cols="12" lg="8" md="8">
                <div class="pa-4" style="height: 100%;background-color:#fafafa;border: 1px dashed #d9d9d9;">
                  {{apitestresult}}
                </div>
             </v-col>
           </v-row>
          <v-btn class="mr-2" color="accent" @click="doAPITest(sellerapi)">Test</v-btn>
          <v-btn color="primary" @click="simpanAPI">Lanjut</v-btn>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-row justify="center">
            <img class="imgconfm" alt="waitingconfm" src="../assets/sellerverificationsuccess.png"/>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import KTPUpload from '@/components/KTPUpload'
import { mapActions, mapState } from 'vuex'
import NPWPUpload from '@/components/NPWPUpload'
export default {
  name: 'SellerRegistration',
  components: { NPWPUpload, KTPUpload },
  data: () => ({
    jenisapi: 1,
    jenisapis: [
      { id: 1, name: 'IRS' },
      { id: 2, name: 'OTOMAX' }
    ]
    // sellerapi: {
    //   jenisapi: 0,
    //   username: '',
    //   password: '',
    //   userid: 'PA0001',
    //   pin: '',
    //   apiurl: ''
    // }
  }),
  mounted () {
    this.getSellerAPI()
  },
  computed: {
    ...mapState('SellerStore', ['apitestresult', 'stepsellerreg', 'sellerapi', 'sellerdoc'])
  },
  methods: {
    ...mapActions('SellerStore', ['doAPITest', 'getSellerAPI', 'simpanSellerAPI', 'setstepsellerreg', 'setSellerDocument']),
    simpanAPI (val) {
      this.$confirm('Yakin akan Simpan? pastikan response bukan user password atau pin salah', { color: 'accent', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.simpanSellerAPI(this.sellerapi)
        }
      })
    }
  }
}
</script>

<style scoped>
.boxidentitas {

}
.imgconfm {
  height: 450px;
  width: 100%;
  object-fit: fill;
}
</style>
